import React, { FC, useContext } from 'react';

// Components
import { ConfigContext, GroupSection } from '@velinsi/smp-widgets-ui';
import MatchList from '../../MatchList/MatchList';

// Types
import { defaultHandleTournamentClick, getLabelValue } from '@sportal365/smp-widget-utils';
import { INormalizedStageMatches, ISubscriberInfo } from '../../../../../../packages/types';

interface Props {
  section: INormalizedStageMatches;
  standingsLabel: string;
  standingsUrl: string;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
}

export const RoundMatches: FC<Props> = ({ section, standingsLabel, standingsUrl, handleClick }) => {
  const { dataLabels } = useContext(ConfigContext);
  const { stage, data } = section;

  const handleCompetitionClick = () => defaultHandleTournamentClick(handleClick, stage.id ?? '', stage.name ?? '');

  return (
    <div key={stage.id}>
      <GroupSection
        name={stage?.name}
        url={stage.url}
        target={stage.target}
        locator='stage'
        handleClick={handleCompetitionClick}
        withStandings
        standingsLabel={standingsLabel}
        standingsUrl={standingsUrl}
      />
      {data.map(
        ({ round, matches }) =>
          matches.length > 0 && (
            <div key={round.id}>
              <GroupSection name={`${getLabelValue(dataLabels?.round, '')} ${round.name}`} locator='round' />
              <MatchList matches={matches} handleClick={handleClick} />
            </div>
          ),
      )}
    </div>
  );
};
